export default __webpack_public_path__ + "static/tron-trade-d35459a5bad2d15feb54471f403d5412.png";